import { gql } from '@apollo/client';
import { client as apolloClient } from '@xbcb/apollo-client';

const ENRICH_SUPPORTING_ENTITIES_QUERY = gql`
  query EnrichSupportingEntities(
    $entityType: String!
    $entityValue: String!
    $supportingEntitiesToBeEnriched: [String!]!
  ) {
    enrichSupportingEntities(
      entityType: $entityType
      entityValue: $entityValue
      supportingEntitiesToBeEnriched: $supportingEntitiesToBeEnriched
    ) {
      entities {
        entityId
        entityType
        tags {
          key
          value
        }
      }
    }
  }
`;

export interface EnrichSupportingEntitiesParams {
  entityType: string;
  entityValue: string;
  supportingEntitiesToBeEnriched: string[];
}

export interface EnrichSupportingEntitiesResponse {
  enrichSupportingEntities: {
    entities: Array<{
      entityId: string;
      entityType: string;
      tags: Array<{
        key: string;
        value: string;
      }> | null;
    }>;
  };
}

export const enrichSupportingEntities = async (
  params: EnrichSupportingEntitiesParams,
): Promise<{ data: EnrichSupportingEntitiesResponse }> => {
  const { data } = await apolloClient.query<EnrichSupportingEntitiesResponse>({
    query: ENRICH_SUPPORTING_ENTITIES_QUERY,
    variables: params,
  });

  return { data };
};
